module.exports = __webpack_public_path__ + "img/limacon_curve.a48bad81.png";